import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray
} from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";

import { NotificationsService } from "angular2-notifications";
import { Mensaje } from "../../../mensaje";

@Component({
  selector: "app-administrativo-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  dato: FormGroup;
  tab = 1;
  tieneid: boolean = false;
  tipos = [
    { id: "INSCRIPCION", nombre: "Inscripción" },
    { id: "REINSCRIPCION", nombre: "Reinscripción" },
    { id: "COLEGIATURA", nombre: "Colegiatura" },
    { id: "REINCORPORACION", nombre: "Reincorporación" },
    { id: "REPETICION MATERIA", nombre: "Repeticion Materia" }
  ];

  form_dias = {
    importe: ["", [Validators.required]],
    dia_inicio: ["", [Validators.required]],
    dia_termino: ["", [Validators.required]],
    color: ["", [Validators.required]],
    es_porcentaje: [0],
    quitar_beca: [0],
    importe_mas_beca: [0]
  };
  tamano;

  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };
  time_cal;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private notificacion: NotificationsService
  ) {}

  ngOnInit() {
    this.dato = this.fb.group({
      nombre: ["", [Validators.required]],
      estatus: [0],
      colegiatura_homogenea: [!this.configuracion.sucursal.pagos_por_nivel],
      recargo_homogenea: [!this.configuracion.sucursal.pagos_por_nivel],
      recargo_es_porcentaje: [true],
      recargo_es_fecha:[false],
      planes_pagos_detalles: this.fb.array([]),
      planes_recargos: this.fb.array([])
    });
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  quitarAllMetodo = function() {
    this.dato.controls.colegiatura_homogenea.patchValue(
      !this.dato.controls.colegiatura_homogenea.value
    );
    this.dato.controls.planes_pagos_detalles = this.fb.array([]);
  };

  quitarAllMetodoRecargo = function() {
    this.dato.controls.recargo_homogenea.patchValue(
      !this.dato.controls.recargo_homogenea.value
    );
    this.dato.controls.planes_recargos = this.fb.array([]);
  };

  pintar_tabla(carrera, modelo, recargo = false) {
    carrera.forEach(element => {
      if (!this.dato.controls.colegiatura_homogenea.value) {
        let niveles = [];
        niveles[0] = [];
        niveles[1] = [];
        niveles[2] = [];
        niveles[3] = [];
        niveles[4] = [];
        for (let i = 1; i <= element.numero_periodos; i++) {
          niveles[0].push(
            this.fb.group({
              nivel: [i],
              importe: ["", [Validators.required]]
            })
          );
          niveles[1].push(
            this.fb.group({
              nivel: [i],
              importe: ["", [Validators.required]]
            })
          );
          niveles[2].push(
            this.fb.group({
              nivel: [i],
              importe: ["", [Validators.required]]
            })
          );
          niveles[3].push(
            this.fb.group({
              nivel: [i],
              importe: ["", [Validators.required]]
            })
          );
          niveles[4].push(
            this.fb.group({
              nivel: [i],
              importe: ["", [Validators.required]]
            })
          );
        }

        let formulario = {
          articulos: this.fb.array([
            this.fb.group({
              tipo: [this.tipos[0]],
              articulos_id: ["db61c2cb92dde2df6e62b4b0744f9dce"],
              nombre: this.tipos[0].nombre,
              niveles: this.fb.array(niveles[0])
            }),
            this.fb.group({
              tipo: [this.tipos[1]],
              articulos_id: ["83dae74b6269ce625f4babc3fa613be2"],
              nombre: this.tipos[1].nombre,
              niveles: this.fb.array(niveles[1])
            }),
            this.fb.group({
              tipo: [this.tipos[2]],
              articulos_id: ["12a00afca32cafa9f493f73f2b7f8bcf"],
              nombre: this.tipos[2].nombre,
              niveles: this.fb.array(niveles[2])
            }),
            this.fb.group({
              tipo: [this.tipos[3]],
              articulos_id: ["549ff7cf2b0d4d82ca99ca7999263207"],
              nombre: this.tipos[3].nombre,
              niveles: this.fb.array(niveles[3])
            }),
            this.fb.group({
              tipo: [this.tipos[4]],
              articulos_id: ["62f68b3c282632674ca101d31a52d11e"],
              nombre: this.tipos[4].nombre,
              niveles: this.fb.array(niveles[4])
            })
          ]),
          carreras_id: [element.id, [Validators.required]],
          carreras_nombre: [element.nombre, [Validators.required]]
        };

        (<FormArray>modelo).push(this.fb.group(formulario));
      } else {
        let niveles = [];
        niveles[0] = [];
        niveles[1] = [];
        niveles[2] = [];
        niveles[3] = [];
        niveles[4] = [];
        niveles[0].push(
          this.fb.group({
            nivel: [""],
            importe: ["", [Validators.required]]
          })
        );
        niveles[1].push(
          this.fb.group({
            nivel: [""],
            importe: ["", [Validators.required]]
          })
        );
        niveles[2].push(
          this.fb.group({
            nivel: [""],
            importe: ["", [Validators.required]]
          })
        );
        niveles[3].push(
          this.fb.group({
            nivel: [""],
            importe: ["", [Validators.required]]
          })
        );
        niveles[4].push(
          this.fb.group({
            nivel: [""],
            importe: ["", [Validators.required]]
          })
        );

        let formulario = {
          articulos: this.fb.array([
            this.fb.group({
              tipo: [this.tipos[0]],
              articulos_id: ["db61c2cb92dde2df6e62b4b0744f9dce"],
              nombre: this.tipos[0].nombre,
              niveles: this.fb.array(niveles[0])
            }),
            this.fb.group({
              tipo: [this.tipos[1]],
              articulos_id: ["83dae74b6269ce625f4babc3fa613be2"],
              nombre: this.tipos[1].nombre,
              niveles: this.fb.array(niveles[1])
            }),
            this.fb.group({
              tipo: [this.tipos[2]],
              articulos_id: ["12a00afca32cafa9f493f73f2b7f8bcf"],
              nombre: this.tipos[2].nombre,
              niveles: this.fb.array(niveles[2])
            }),
            this.fb.group({
              tipo: [this.tipos[3]],
              articulos_id: ["549ff7cf2b0d4d82ca99ca7999263207"],
              nombre: this.tipos[3].nombre,
              niveles: this.fb.array(niveles[3])
            }),
            this.fb.group({
              tipo: [this.tipos[4]],
              articulos_id: ["62f68b3c282632674ca101d31a52d11e"],
              nombre: this.tipos[4].nombre,
              niveles: this.fb.array(niveles[4])
            })
          ]),
          carreras_id: [element.id, [Validators.required]],
          carreras_nombre: [element.nombre, [Validators.required]]
        };
        (<FormArray>modelo).push(this.fb.group(formulario));
      }
    });
    if (recargo)
      this.pintar_tabla_recargo(carrera, this.dato.controls.planes_recargos);
  }

  pintar_tabla_recargo(carrera, modelo) {
    carrera.forEach(element => {
      if (!this.dato.controls.recargo_homogenea.value) {
        let niveles = [];
        niveles[0] = [];
        niveles[1] = [];
        niveles[2] = [];
        niveles[3] = [];
        niveles[4] = [];
        for (let i = 1; i <= element.numero_periodos; i++) {
          niveles[0].push(
            this.fb.group({
              nivel: [i],
              planes_recargos_detalles: this.fb.array([]),
              es_acumulado: [false]
            })
          );
          niveles[1].push(
            this.fb.group({
              nivel: [i],
              planes_recargos_detalles: this.fb.array([]),
              es_acumulado: [false]
            })
          );
          niveles[2].push(
            this.fb.group({
              nivel: [i],
              planes_recargos_detalles: this.fb.array([]),
              es_acumulado: [false]
            })
          );
          niveles[3].push(
            this.fb.group({
              nivel: [i],
              planes_recargos_detalles: this.fb.array([]),
              es_acumulado: [false]
            })
          );
          niveles[4].push(
            this.fb.group({
              nivel: [i],
              planes_recargos_detalles: this.fb.array([]),
              es_acumulado: [false]
            })
          );
        }

        let formulario = {
          articulos: this.fb.array([
            this.fb.group({
              tipo: [this.tipos[0]],
              articulos_id: ["db61c2cb92dde2df6e62b4b0744f9dce"],
              nombre: this.tipos[0].nombre,
              niveles: this.fb.array(niveles[0])
            }),
            this.fb.group({
              tipo: [this.tipos[1]],
              articulos_id: ["83dae74b6269ce625f4babc3fa613be2"],
              nombre: this.tipos[1].nombre,
              niveles: this.fb.array(niveles[1])
            }),
            this.fb.group({
              tipo: [this.tipos[2]],
              articulos_id: ["12a00afca32cafa9f493f73f2b7f8bcf"],
              nombre: this.tipos[2].nombre,
              niveles: this.fb.array(niveles[2])
            }),
            this.fb.group({
              tipo: [this.tipos[3]],
              articulos_id: ["549ff7cf2b0d4d82ca99ca7999263207"],
              nombre: this.tipos[3].nombre,
              niveles: this.fb.array(niveles[3])
            }),
            this.fb.group({
              tipo: [this.tipos[4]],
              articulos_id: ["62f68b3c282632674ca101d31a52d11e"],
              nombre: this.tipos[4].nombre,
              niveles: this.fb.array(niveles[4])
            })
          ]),
          carreras_id: [element.id, [Validators.required]],
          carreras_nombre: [element.nombre, [Validators.required]]
        };

        (<FormArray>modelo).push(this.fb.group(formulario));
      } else {
        let niveles = [];
        niveles[0] = [];
        niveles[1] = [];
        niveles[2] = [];
        niveles[3] = [];
        niveles[4] = [];
        niveles[0].push(
          this.fb.group({
            nivel: [""],
            planes_recargos_detalles: this.fb.array([]),
            es_acumulado: [false]
          })
        );
        niveles[1].push(
          this.fb.group({
            nivel: [""],
            planes_recargos_detalles: this.fb.array([]),
            es_acumulado: [false]
          })
        );
        niveles[2].push(
          this.fb.group({
            nivel: [""],
            planes_recargos_detalles: this.fb.array([]),
            es_acumulado: [false]
          })
        );
        niveles[3].push(
          this.fb.group({
            nivel: [""],
            planes_recargos_detalles: this.fb.array([]),
            es_acumulado: [false]
          })
        );
        niveles[4].push(
          this.fb.group({
            nivel: [""],
            planes_recargos_detalles: this.fb.array([]),
            es_acumulado: [false]
          })
        );

        let formulario = {
          articulos: this.fb.array([
            this.fb.group({
              tipo: [this.tipos[0]],
              articulos_id: ["db61c2cb92dde2df6e62b4b0744f9dce"],
              nombre: this.tipos[0].nombre,
              niveles: this.fb.array(niveles[0])
            }),
            this.fb.group({
              tipo: [this.tipos[1]],
              articulos_id: ["83dae74b6269ce625f4babc3fa613be2"],
              nombre: this.tipos[1].nombre,
              niveles: this.fb.array(niveles[1])
            }),
            this.fb.group({
              tipo: [this.tipos[2]],
              articulos_id: ["12a00afca32cafa9f493f73f2b7f8bcf"],
              nombre: this.tipos[2].nombre,
              niveles: this.fb.array(niveles[2])
            }),
            this.fb.group({
              tipo: [this.tipos[3]],
              articulos_id: ["549ff7cf2b0d4d82ca99ca7999263207"],
              nombre: this.tipos[3].nombre,
              niveles: this.fb.array(niveles[3])
            }),
            this.fb.group({
              tipo: [this.tipos[4]],
              articulos_id: ["62f68b3c282632674ca101d31a52d11e"],
              nombre: this.tipos[4].nombre,
              niveles: this.fb.array(niveles[4])
            })
          ]),
          carreras_id: [element.id, [Validators.required]],
          carreras_nombre: [element.nombre, [Validators.required]]
        };
        (<FormArray>modelo).push(this.fb.group(formulario));
      }
    });
  }

  validar_min(event, modelo, min) {
    if (
      event.key != "Tab" &&
      event.key != "CapsLock" &&
      event.key != "Shift" &&
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cal);
      this.time_cal = setTimeout(() => {
        if (modelo < min) {
          event.srcElement.value = min;
          modelo = min;
          this.mensajeResponse.titulo = "Minimo";
          this.mensajeResponse.texto =
            "El minimo valor para este campo es: " + min;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      }, 500);
    }
  }

  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }
}
